<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    :floating="!sideBarShowBorder"
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    :expand-on-hover="sidBarHoverExpand"
    @input="(val) => $emit('update:is-drawer-open', val)"
  >
    <app-logo></app-logo>

    <v-list
      expand
      :shaped="sideBarButtonStyle === 'shaped'"
      :rounded="sideBarButtonStyle === 'rounded'"
    >
      <div class="mb-1">
        <v-list-item
          v-if="showHome"
          :to="homePage"
          class="vertical-nav-menu-link"
          active-class="bg-gradient-primary white--text"
        >
          <v-list-item-icon>
            <v-icon>mdi-home-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ home }} </v-list-item-title>
        </v-list-item>
      </div>

      <vertical-nav-menu-item :menus="menus"></vertical-nav-menu-item>

      <template v-if="isInRole('admin')">
        <vertical-nav-menu-item :menus="devMenus"></vertical-nav-menu-item>
      </template>
    </v-list>

    <template v-if="sideBarShowSignout" v-slot:append>
      <v-list
        expand
        :shaped="sideBarButtonStyle === 'shaped'"
        :rounded="sideBarButtonStyle === 'rounded'"
      >
        <v-list-item
          v-if="signedin"
          class="vertical-nav-menu-link"
          active-class="bg-gradient-primary white--text"
          @click="signout"
        >
          <v-list-item-icon>
            <v-icon>mdi-logout-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ logoff }}</v-list-item-title>
        </v-list-item>

        <v-list-item
          v-else
          class="vertical-nav-menu-link"
          active-class="bg-gradient-primary white--text"
          to="/signin"
        >
          <v-list-item-icon>
            <v-icon>mdi-login-variant</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ login }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useLocalStore } from "../../../store/local";
import { useUserStore } from "../../../store/user";
import { useAppStore } from "../../../store/app";
import { devMenus } from "../../../router/dev";

import AppLogo from "../AppLogo.vue";
import VerticalNavMenuItem from "./VerticalNavMenuItem.vue";

export default {
  name: "SideBar",

  components: {
    AppLogo,
    VerticalNavMenuItem,
  },

  props: {
    isDrawerOpen: {
      type: Boolean,
      default: null,
    },
  },

  data() {
    return {
      menus: [],
      devMenus,
    };
  },

  computed: {
    ...mapState(useAppStore, {
      sideBarShowBorder: (store) => store.config.sideBarShowBorder,
      appTitle: (store) => store.config.appTitle,
      appIcon: (store) => store.config.appIcon,
      sideBarButtonStyle: (store) => store.config.sideBarButtonStyle,
      showHome: (store) => store.config.showHome,
      sideBarShowSignout: (store) => store.config.sideBarShowSignout,
      sidBarHoverExpand: (store) => store.config.sidBarHoverExpand,
    }),
    ...mapState(useLocalStore, ["home", "developer", "login", "logoff"]),
    ...mapState(useUserStore, ["signedin", "homePage", "roles"]),
    ...mapState(useAppStore, ["projectMenus"]),
  },

  async mounted() {
    let menus = this.projectMenus;

    if (menus) {
      for (let i = 0; i < menus.length; i++) {
        const e = menus[i];

        if (e.area != "main") {
          if (e.role) {
            if (this.isInRole(e.role)) {
              this.menus.push(e);
            }

            continue;
          }

          this.menus.push(e);
        }
      }
    }

    menus = await this.getSideMenus();

    menus.sort((a, b) => a.visibleIndex - b.visibleIndex);

    menus.forEach((x) => {
      x.children.sort((a, b) => a.visibleIndex - b.visibleIndex);
    });

    if (menus) {
      for (let i = 0; i < menus.length; i++) {
        const e = menus[i];

        if (e.role) {
          if (this.isInRole(e.role)) this.menus.push(e);
          continue;
        }

        this.menus.push(e);
      }
    }
  },

  methods: {
    openUrl(type, url) {
      if (type == "url") window.open(url);
    },
    async signout() {
      const userStore = useUserStore();
      await userStore.signout();
    },

    ...mapActions(useUserStore, ["isInRole", "getSideMenus"]),
  },
};
</script>

<style lang="scss" scoped>
.app-navigation-menu {
  .v-list-item {
    &.vertical-nav-menu-link {
      ::v-deep .v-list-item__icon {
        .v-icon {
          transition: none !important;
        }
      }
    }
  }
}

.vertical-nav-menu-link {
  &.v-list-item--active {
    box-shadow: 0 5px 10px -4px rgba(94, 86, 105, 0.42);
  }

  .vertical-nav-menu-link-subicon {
    font-size: 14px;
    margin-left: 4px;
    margin-top: 4px;
    color: #c0c0c0;
  }
}
</style>
